import React, { useLayoutEffect, useRef, useState } from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { expandableItemStyles } from './expandable-item-helper';

interface ExpandableItemProps {
    textMessage: string;
    textMessageWidth?: number;
    isWordCount?: boolean;
    customStyles?: SxProps;
}

export const ExpandableItem = ({
    textMessage,
    textMessageWidth = 0,
    isWordCount = false,
    customStyles,
}: ExpandableItemProps): React.JSX.Element => {
    const [isIconExpanded, setIsIconExpanded] = useState<boolean>(false);
    const [isLongMessage, setIsLongMessage] = useState<boolean>(false);
    const messageRef = useRef<HTMLElement>(null);

    useLayoutEffect(() => {
        if (messageRef.current) {
            if (isWordCount) {
                setIsLongMessage(true);
            } else {
                setIsLongMessage(
                    messageRef.current.clientWidth >= textMessageWidth - 34
                );
            }
        }
    }, [messageRef.current, textMessageWidth, isWordCount]);

    const onExpandIconClick = (e: React.MouseEvent): void => {
        e.stopPropagation();
        setIsIconExpanded((prevState) => !prevState);
    };

    const getTextMessageStyles = (): any => {
        let computedWidth: string;
        if (textMessageWidth) {
            computedWidth = `${textMessageWidth - 34}px !important`;
        } else {
            computedWidth = '100%';
        }

        if (isLongMessage && isIconExpanded) {
            return {
                ...expandableItemStyles.truncatedExpandedMessage,
                width: computedWidth,
            };
        } else if (isLongMessage && !isIconExpanded) {
            return {
                ...expandableItemStyles.truncatedHiddenMessage,
                width: computedWidth,
            };
        } else {
            return {
                ...expandableItemStyles.hiddenMessage,
                width: '100%',
            };
        }
    };

    return (
        <Box sx={{ ...customStyles, display: 'flex' }}>
            <Typography
                ref={messageRef}
                sx={{
                    ...getTextMessageStyles(),
                }}
            >
                {textMessage}
            </Typography>
            {isLongMessage &&
                (isIconExpanded ? (
                    <ExpandMoreIcon
                        sx={expandableItemStyles.icon}
                        onClick={(e: any): void => onExpandIconClick(e)}
                    />
                ) : (
                    <ExpandLessIcon
                        sx={expandableItemStyles.icon}
                        onClick={(e: any): void => onExpandIconClick(e)}
                    />
                ))}
        </Box>
    );
};
